// Team Insights — Payouts / wallet / KYC strings (prefix `ins.pay.`)
const en = {
  "ins.pay.holder": "Account holder",
  "ins.pay.schedule": "Payout schedule",
  "ins.pay.status": "Status",
  "ins.pay.eligibleNow": "You can request a payout now",
  "ins.pay.nextWindow": "Next request window: {date}",
  "ins.pay.notEligible": "{n} step(s) left before you can withdraw",
  "ins.pay.minimum": "Minimum payout",
  "ins.pay.weekly": "Requests this week",
  "ins.pay.weekResets": "Weekly limit resets",
  "ins.pay.paidOut": "Paid out to date",
  "ins.pay.readyTitle": "Get ready to withdraw",
  "ins.pay.readyDesc": "Complete these steps once — then withdrawals take just a few clicks.",
  "ins.pay.step.profile": "Payout profile & tax info",
  "ins.pay.step.profileDesc": "Legal name, address and tax details used on your payouts.",
  "ins.pay.step.kyc": "Identity verification",
  "ins.pay.step.kycDesc": "Upload an ID document so we can verify it's really you.",
  "ins.pay.step.method": "Payout method",
  "ins.pay.step.methodDesc": "Add and verify a bank account or PayPal address.",
  "ins.pay.step.balance": "Reach {min} withdrawable",
  "ins.pay.step.balanceOk": "Your balance is above the minimum payout.",
  "ins.pay.step.balanceDesc": "{amount} more to reach the minimum payout.",
  "ins.pay.kyc.not_submitted": "Not submitted",
  "ins.pay.kyc.pending": "Under review",
  "ins.pay.kyc.approved": "Verified",
  "ins.pay.kyc.rejected": "Rejected",
  "ins.pay.kyc.not_submittedDesc": "Upload an ID document so we can verify it's really you.",
  "ins.pay.kyc.pendingDesc": "Your documents are being reviewed. This usually takes 1–2 business days.",
  "ins.pay.kyc.approvedDesc": "Your identity has been verified.",
  "ins.pay.kyc.rejectedDesc": "Your verification was rejected. Please check your documents and submit again.",
  "ins.pay.start": "Start",
  "ins.pay.edit": "Edit",
  "ins.pay.add": "Add",
  "ins.pay.resubmit": "Resubmit",
  "ins.pay.activity": "Activity",
  "ins.pay.profileTab": "Payout profile",
  "ins.pay.timeline": "Earnings & payouts timeline",
  "ins.pay.timelineEmpty": "No earnings or payouts yet. Your royalties will appear here once reports come in.",
  "ins.pay.withdrawal": "Withdrawal",
  "ins.pay.period": "Period",
  "ins.pay.complete": "Complete",
  "ins.pay.incomplete": "Incomplete",
  "ins.pay.notReady": "Complete all payout steps before requesting a withdrawal.",
  "ins.pay.minError": "The minimum payout amount is {min}.",
  "ins.pay.minShort": "Min. {min}",
  "ins.pay.maxShort": "Max. {max}",
  "ins.pay.withdrawAll": "Withdraw all",
  "ins.pay.country": "Country",
  "ins.pay.select": "Select…",
  "ins.pay.currency": "Currency",
  "ins.pay.accountNumber": "Account number",
  "ins.pay.routing": "Routing / sort code",
  "ins.pay.otpNote": "For your security, every payout change is confirmed with a one-time code sent to your email.",
  "ins.pay.expires": "Expires",
  "ins.pay.expiresIn": "Code expires in {time}",
  "ins.pay.codeExpired": "Code expired — request a new one.",
  "ins.pay.taxCountryRequired": "Please select your tax country.",
  "ins.pay.taxIdRequired": "Please enter your tax ID.",
  "ins.pay.taxIdInvalid": "Invalid tax ID format. Example: {example}",
  "ins.pay.profileTitle": "Payout profile",
  "ins.pay.profileDesc": "This information must match your bank account and is used for tax reporting.",
  "ins.pay.profileType": "Profile type",
  "ins.pay.identity": "Identity",
  "ins.pay.firstName": "Legal first name",
  "ins.pay.lastName": "Legal last name",
  "ins.pay.displayName": "Display name",
  "ins.pay.phone": "Phone",
  "ins.pay.companyName": "Company name",
  "ins.pay.companyReg": "Company registration no.",
  "ins.pay.vat": "VAT number",
  "ins.pay.address": "Address",
  "ins.pay.city": "City",
  "ins.pay.state": "State / province",
  "ins.pay.postal": "Postal code",
  "ins.pay.address1": "Address line 1",
  "ins.pay.address2": "Address line 2",
  "ins.pay.tax": "Tax information",
  "ins.pay.taxStatus": "Tax status",
  "ins.pay.taxCountry": "Tax country",
  "ins.pay.taxId": "Tax ID",
  "ins.pay.taxIdKeep": "leave blank to keep",
  "ins.pay.taxIdEncrypted": "Your tax ID is encrypted and never shown in full.",
  "ins.pay.kycDocType": "Document must be a PDF, JPEG or PNG file.",
  "ins.pay.kycSelfieType": "Selfie must be a JPEG or PNG image.",
  "ins.pay.kycTooLarge": "File is too large (max {mb} MB).",
  "ins.pay.kycNeedDocType": "Please choose a document type.",
  "ins.pay.kycNeedCountry": "Please select the issuing country.",
  "ins.pay.kycNeedName": "Please enter your full name.",
  "ins.pay.kycNeedDob": "Please enter your date of birth.",
  "ins.pay.kycNeedDoc": "Please upload your ID document.",
  "ins.pay.kycSubmitted": "Documents submitted. We'll notify you once they're reviewed.",
  "ins.pay.kycFailed": "Could not submit your documents. Please try again.",
  "ins.pay.kycTitle": "Verify your identity",
  "ins.pay.kycDesc": "Required by law before we can send you money. Takes about 2 minutes.",
  "ins.pay.kycDocTypeLabel": "Document type",
  "ins.pay.doc.passport": "Passport",
  "ins.pay.doc.id_card": "ID card",
  "ins.pay.doc.drivers_license": "Driver's license",
  "ins.pay.kycFullName": "Full name (as on document)",
  "ins.pay.kycDob": "Date of birth",
  "ins.pay.kycCountry": "Issuing country",
  "ins.pay.kycDocNumber": "Document number",
  "ins.pay.kycUploadDoc": "Upload ID document",
  "ins.pay.kycDocHint": "PDF, JPEG or PNG · max 10 MB",
  "ins.pay.kycUploadSelfie": "Upload a selfie (optional)",
  "ins.pay.kycSelfieHint": "JPEG or PNG · max 5 MB · speeds up review",
  "ins.pay.kycPrivacy": "Your documents are stored securely and only used for identity verification.",
  "ins.pay.kycSubmit": "Submit for review",
};

const tr = {
  "ins.pay.holder": "Hesap sahibi",
  "ins.pay.schedule": "Ödeme takvimi",
  "ins.pay.status": "Durum",
  "ins.pay.eligibleNow": "Şimdi ödeme talep edebilirsiniz",
  "ins.pay.nextWindow": "Sonraki talep zamanı: {date}",
  "ins.pay.notEligible": "Para çekebilmek için {n} adım kaldı",
  "ins.pay.minimum": "Minimum ödeme",
  "ins.pay.weekly": "Bu haftaki talepler",
  "ins.pay.weekResets": "Haftalık limit sıfırlanır",
  "ins.pay.paidOut": "Bugüne kadar ödenen",
  "ins.pay.readyTitle": "Para çekmeye hazırlanın",
  "ins.pay.readyDesc": "Bu adımları bir kez tamamlayın — sonrasında para çekmek birkaç tıklama sürer.",
  "ins.pay.step.profile": "Ödeme profili ve vergi bilgileri",
  "ins.pay.step.profileDesc": "Ödemelerinizde kullanılan yasal ad, adres ve vergi bilgileri.",
  "ins.pay.step.kyc": "Kimlik doğrulama",
  "ins.pay.step.kycDesc": "Kimliğinizi doğrulayabilmemiz için bir kimlik belgesi yükleyin.",
  "ins.pay.step.method": "Ödeme yöntemi",
  "ins.pay.step.methodDesc": "Bir banka hesabı veya PayPal adresi ekleyip doğrulayın.",
  "ins.pay.step.balance": "Çekilebilir bakiye {min} olmalı",
  "ins.pay.step.balanceOk": "Bakiyeniz minimum ödeme tutarının üzerinde.",
  "ins.pay.step.balanceDesc": "Minimum ödemeye ulaşmak için {amount} daha gerekli.",
  "ins.pay.kyc.not_submitted": "Gönderilmedi",
  "ins.pay.kyc.pending": "İnceleniyor",
  "ins.pay.kyc.approved": "Doğrulandı",
  "ins.pay.kyc.rejected": "Reddedildi",
  "ins.pay.kyc.not_submittedDesc": "Kimliğinizi doğrulayabilmemiz için bir kimlik belgesi yükleyin.",
  "ins.pay.kyc.pendingDesc": "Belgeleriniz inceleniyor. Bu genellikle 1–2 iş günü sürer.",
  "ins.pay.kyc.approvedDesc": "Kimliğiniz doğrulandı.",
  "ins.pay.kyc.rejectedDesc": "Doğrulamanız reddedildi. Lütfen belgelerinizi kontrol edip tekrar gönderin.",
  "ins.pay.start": "Başla",
  "ins.pay.edit": "Düzenle",
  "ins.pay.add": "Ekle",
  "ins.pay.resubmit": "Tekrar gönder",
  "ins.pay.activity": "Hareketler",
  "ins.pay.profileTab": "Ödeme profili",
  "ins.pay.timeline": "Kazanç ve ödeme geçmişi",
  "ins.pay.timelineEmpty": "Henüz kazanç veya ödeme yok. Raporlar geldiğinde telif gelirleriniz burada görünecek.",
  "ins.pay.withdrawal": "Para çekme",
  "ins.pay.period": "Dönem",
  "ins.pay.complete": "Tamamlandı",
  "ins.pay.incomplete": "Eksik",
  "ins.pay.notReady": "Para çekme talebinden önce tüm ödeme adımlarını tamamlayın.",
  "ins.pay.minError": "Minimum ödeme tutarı {min}.",
  "ins.pay.minShort": "Min. {min}",
  "ins.pay.maxShort": "Maks. {max}",
  "ins.pay.withdrawAll": "Tümünü çek",
  "ins.pay.country": "Ülke",
  "ins.pay.select": "Seçin…",
  "ins.pay.currency": "Para birimi",
  "ins.pay.accountNumber": "Hesap numarası",
  "ins.pay.routing": "Routing / sort kodu",
  "ins.pay.otpNote": "Güvenliğiniz için her ödeme değişikliği e-postanıza gönderilen tek kullanımlık kodla onaylanır.",
  "ins.pay.expires": "Süre",
  "ins.pay.expiresIn": "Kodun süresi {time} içinde doluyor",
  "ins.pay.codeExpired": "Kodun süresi doldu — yeni kod isteyin.",
  "ins.pay.taxCountryRequired": "Lütfen vergi ülkenizi seçin.",
  "ins.pay.taxIdRequired": "Lütfen vergi numaranızı girin.",
  "ins.pay.taxIdInvalid": "Geçersiz vergi numarası formatı. Örnek: {example}",
  "ins.pay.profileTitle": "Ödeme profili",
  "ins.pay.profileDesc": "Bu bilgiler banka hesabınızla eşleşmeli; vergi raporlamasında kullanılır.",
  "ins.pay.profileType": "Profil türü",
  "ins.pay.identity": "Kimlik",
  "ins.pay.firstName": "Yasal ad",
  "ins.pay.lastName": "Yasal soyad",
  "ins.pay.displayName": "Görünen ad",
  "ins.pay.phone": "Telefon",
  "ins.pay.companyName": "Şirket adı",
  "ins.pay.companyReg": "Ticaret sicil no.",
  "ins.pay.vat": "KDV numarası",
  "ins.pay.address": "Adres",
  "ins.pay.city": "Şehir",
  "ins.pay.state": "İl / eyalet",
  "ins.pay.postal": "Posta kodu",
  "ins.pay.address1": "Adres satırı 1",
  "ins.pay.address2": "Adres satırı 2",
  "ins.pay.tax": "Vergi bilgileri",
  "ins.pay.taxStatus": "Vergi durumu",
  "ins.pay.taxCountry": "Vergi ülkesi",
  "ins.pay.taxId": "Vergi numarası",
  "ins.pay.taxIdKeep": "korumak için boş bırakın",
  "ins.pay.taxIdEncrypted": "Vergi numaranız şifrelenir ve asla tam olarak gösterilmez.",
  "ins.pay.kycDocType": "Belge PDF, JPEG veya PNG olmalıdır.",
  "ins.pay.kycSelfieType": "Selfie JPEG veya PNG olmalıdır.",
  "ins.pay.kycTooLarge": "Dosya çok büyük (en fazla {mb} MB).",
  "ins.pay.kycNeedDocType": "Lütfen belge türünü seçin.",
  "ins.pay.kycNeedCountry": "Lütfen belgeyi veren ülkeyi seçin.",
  "ins.pay.kycNeedName": "Lütfen adınızı ve soyadınızı girin.",
  "ins.pay.kycNeedDob": "Lütfen doğum tarihinizi girin.",
  "ins.pay.kycNeedDoc": "Lütfen kimlik belgenizi yükleyin.",
  "ins.pay.kycSubmitted": "Belgeler gönderildi. İncelendiğinde size haber vereceğiz.",
  "ins.pay.kycFailed": "Belgeler gönderilemedi. Lütfen tekrar deneyin.",
  "ins.pay.kycTitle": "Kimliğinizi doğrulayın",
  "ins.pay.kycDesc": "Size ödeme gönderebilmemiz için yasal olarak gereklidir. Yaklaşık 2 dakika sürer.",
  "ins.pay.kycDocTypeLabel": "Belge türü",
  "ins.pay.doc.passport": "Pasaport",
  "ins.pay.doc.id_card": "Kimlik kartı",
  "ins.pay.doc.drivers_license": "Ehliyet",
  "ins.pay.kycFullName": "Ad soyad (belgedeki gibi)",
  "ins.pay.kycDob": "Doğum tarihi",
  "ins.pay.kycCountry": "Belgeyi veren ülke",
  "ins.pay.kycDocNumber": "Belge numarası",
  "ins.pay.kycUploadDoc": "Kimlik belgesi yükle",
  "ins.pay.kycDocHint": "PDF, JPEG veya PNG · en fazla 10 MB",
  "ins.pay.kycUploadSelfie": "Selfie yükle (isteğe bağlı)",
  "ins.pay.kycSelfieHint": "JPEG veya PNG · en fazla 5 MB · incelemeyi hızlandırır",
  "ins.pay.kycPrivacy": "Belgeleriniz güvenle saklanır ve yalnızca kimlik doğrulama için kullanılır.",
  "ins.pay.kycSubmit": "İncelemeye gönder",
};

const es = {
  "ins.pay.holder": "Titular de la cuenta",
  "ins.pay.schedule": "Calendario de pagos",
  "ins.pay.status": "Estado",
  "ins.pay.eligibleNow": "Ya puedes solicitar un pago",
  "ins.pay.nextWindow": "Próxima ventana de solicitud: {date}",
  "ins.pay.notEligible": "Te faltan {n} paso(s) para poder retirar",
  "ins.pay.minimum": "Pago mínimo",
  "ins.pay.weekly": "Solicitudes esta semana",
  "ins.pay.weekResets": "El límite semanal se reinicia",
  "ins.pay.paidOut": "Pagado hasta la fecha",
  "ins.pay.readyTitle": "Prepárate para retirar",
  "ins.pay.readyDesc": "Completa estos pasos una vez y retirar te llevará solo unos clics.",
  "ins.pay.step.profile": "Perfil de pago e información fiscal",
  "ins.pay.step.profileDesc": "Nombre legal, dirección y datos fiscales usados en tus pagos.",
  "ins.pay.step.kyc": "Verificación de identidad",
  "ins.pay.step.kycDesc": "Sube un documento de identidad para que podamos verificar que eres tú.",
  "ins.pay.step.method": "Método de pago",
  "ins.pay.step.methodDesc": "Añade y verifica una cuenta bancaria o una dirección de PayPal.",
  "ins.pay.step.balance": "Alcanza {min} disponibles",
  "ins.pay.step.balanceOk": "Tu saldo supera el pago mínimo.",
  "ins.pay.step.balanceDesc": "Faltan {amount} para alcanzar el pago mínimo.",
  "ins.pay.kyc.not_submitted": "No enviado",
  "ins.pay.kyc.pending": "En revisión",
  "ins.pay.kyc.approved": "Verificado",
  "ins.pay.kyc.rejected": "Rechazado",
  "ins.pay.kyc.not_submittedDesc": "Sube un documento de identidad para que podamos verificar que eres tú.",
  "ins.pay.kyc.pendingDesc": "Estamos revisando tus documentos. Suele tardar 1–2 días hábiles.",
  "ins.pay.kyc.approvedDesc": "Tu identidad ha sido verificada.",
  "ins.pay.kyc.rejectedDesc": "Tu verificación fue rechazada. Revisa tus documentos y envíalos de nuevo.",
  "ins.pay.start": "Empezar",
  "ins.pay.edit": "Editar",
  "ins.pay.add": "Añadir",
  "ins.pay.resubmit": "Reenviar",
  "ins.pay.activity": "Actividad",
  "ins.pay.profileTab": "Perfil de pago",
  "ins.pay.timeline": "Historial de ganancias y pagos",
  "ins.pay.timelineEmpty": "Aún no hay ganancias ni pagos. Tus regalías aparecerán aquí cuando lleguen los informes.",
  "ins.pay.withdrawal": "Retiro",
  "ins.pay.period": "Periodo",
  "ins.pay.complete": "Completo",
  "ins.pay.incomplete": "Incompleto",
  "ins.pay.notReady": "Completa todos los pasos de pago antes de solicitar un retiro.",
  "ins.pay.minError": "El importe mínimo de pago es {min}.",
  "ins.pay.minShort": "Mín. {min}",
  "ins.pay.maxShort": "Máx. {max}",
  "ins.pay.withdrawAll": "Retirar todo",
  "ins.pay.country": "País",
  "ins.pay.select": "Seleccionar…",
  "ins.pay.currency": "Moneda",
  "ins.pay.accountNumber": "Número de cuenta",
  "ins.pay.routing": "Código routing / sort",
  "ins.pay.otpNote": "Por tu seguridad, cada cambio de pago se confirma con un código de un solo uso enviado a tu correo.",
  "ins.pay.expires": "Caduca",
  "ins.pay.expiresIn": "El código caduca en {time}",
  "ins.pay.codeExpired": "El código ha caducado: solicita uno nuevo.",
  "ins.pay.taxCountryRequired": "Selecciona tu país de residencia fiscal.",
  "ins.pay.taxIdRequired": "Introduce tu número de identificación fiscal.",
  "ins.pay.taxIdInvalid": "Formato de identificación fiscal no válido. Ejemplo: {example}",
  "ins.pay.profileTitle": "Perfil de pago",
  "ins.pay.profileDesc": "Estos datos deben coincidir con tu cuenta bancaria y se usan para fines fiscales.",
  "ins.pay.profileType": "Tipo de perfil",
  "ins.pay.identity": "Identidad",
  "ins.pay.firstName": "Nombre legal",
  "ins.pay.lastName": "Apellidos legales",
  "ins.pay.displayName": "Nombre visible",
  "ins.pay.phone": "Teléfono",
  "ins.pay.companyName": "Nombre de la empresa",
  "ins.pay.companyReg": "N.º de registro mercantil",
  "ins.pay.vat": "Número de IVA",
  "ins.pay.address": "Dirección",
  "ins.pay.city": "Ciudad",
  "ins.pay.state": "Estado / provincia",
  "ins.pay.postal": "Código postal",
  "ins.pay.address1": "Dirección, línea 1",
  "ins.pay.address2": "Dirección, línea 2",
  "ins.pay.tax": "Información fiscal",
  "ins.pay.taxStatus": "Situación fiscal",
  "ins.pay.taxCountry": "País fiscal",
  "ins.pay.taxId": "Identificación fiscal",
  "ins.pay.taxIdKeep": "déjalo vacío para mantenerlo",
  "ins.pay.taxIdEncrypted": "Tu identificación fiscal se cifra y nunca se muestra completa.",
  "ins.pay.kycDocType": "El documento debe ser PDF, JPEG o PNG.",
  "ins.pay.kycSelfieType": "El selfie debe ser una imagen JPEG o PNG.",
  "ins.pay.kycTooLarge": "El archivo es demasiado grande (máx. {mb} MB).",
  "ins.pay.kycNeedDocType": "Elige un tipo de documento.",
  "ins.pay.kycNeedCountry": "Selecciona el país emisor.",
  "ins.pay.kycNeedName": "Introduce tu nombre completo.",
  "ins.pay.kycNeedDob": "Introduce tu fecha de nacimiento.",
  "ins.pay.kycNeedDoc": "Sube tu documento de identidad.",
  "ins.pay.kycSubmitted": "Documentos enviados. Te avisaremos cuando se revisen.",
  "ins.pay.kycFailed": "No se pudieron enviar tus documentos. Inténtalo de nuevo.",
  "ins.pay.kycTitle": "Verifica tu identidad",
  "ins.pay.kycDesc": "Es un requisito legal antes de poder enviarte dinero. Tarda unos 2 minutos.",
  "ins.pay.kycDocTypeLabel": "Tipo de documento",
  "ins.pay.doc.passport": "Pasaporte",
  "ins.pay.doc.id_card": "Documento de identidad",
  "ins.pay.doc.drivers_license": "Permiso de conducir",
  "ins.pay.kycFullName": "Nombre completo (como en el documento)",
  "ins.pay.kycDob": "Fecha de nacimiento",
  "ins.pay.kycCountry": "País emisor",
  "ins.pay.kycDocNumber": "Número de documento",
  "ins.pay.kycUploadDoc": "Subir documento de identidad",
  "ins.pay.kycDocHint": "PDF, JPEG o PNG · máx. 10 MB",
  "ins.pay.kycUploadSelfie": "Subir un selfie (opcional)",
  "ins.pay.kycSelfieHint": "JPEG o PNG · máx. 5 MB · agiliza la revisión",
  "ins.pay.kycPrivacy": "Tus documentos se guardan de forma segura y solo se usan para verificar tu identidad.",
  "ins.pay.kycSubmit": "Enviar a revisión",
};

export default { en, tr, es };
